import * as React from "react";
import { IconProps } from "./IconProps";

export const IconCheckBookmark = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.3565 19.8102 21.686 19.5019 21.8649C19.1936 22.0438 18.8134 22.0451 18.5039 21.8682L12 18.1518L5.49614 21.8682C5.18664 22.0451 4.80639 22.0438 4.49807 21.8649C4.18976 21.686 4 21.3565 4 21V3ZM6 4V19.2768L11.5039 16.1318C11.8113 15.9561 12.1887 15.9561 12.4961 16.1318L18 19.2768V4H6ZM15.2071 7.54289C15.5976 7.93342 15.5976 8.56658 15.2071 8.95711L11.7071 12.4571C11.3166 12.8476 10.6834 12.8476 10.2929 12.4571L8.79289 10.9571C8.40237 10.5666 8.40237 9.93342 8.79289 9.54289C9.18342 9.15237 9.81658 9.15237 10.2071 9.54289L11 10.3358L13.7929 7.54289C14.1834 7.15237 14.8166 7.15237 15.2071 7.54289Z"
          fill={color}
        />
      </svg>
    );
  },
);
